/*
 * Gift guide add to cart: the per-product button (snippets/gift-guide-item)
 * and "tap to shop" (adds every product shown in that guide). Then a notice
 * in the middle of the screen says what went in, with View cart.
 *
 * Incoming units get the same "Estimated arrival" line-item property as the
 * product page's cart split (sections/product-template.liquid), worked out
 * from the same snippets/variant-stock numbers: in stock first, then the
 * soonest arrival. One unit per product, so there is nothing to split.
 * Sold-out and call-for-price products are never added; tap to shop lists them.
 */
(function () {
  if (window.ahhGiftGuideCart) return;
  window.ahhGiftGuideCart = true;

  function fmtDate(iso) {
    if (!iso) return 'Arrival date to be confirmed';
    // Parse YYYY-MM-DD as a local date (new Date("YYYY-MM-DD") is UTC and
    // would show a day early west of UTC).
    var m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
    var d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(iso);
    if (isNaN(d.getTime())) return 'Arrival date to be confirmed';
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }

  function dataOf(li) {
    var el = li && li.querySelector('.gg__data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // One unit of the product's variant as a /cart/add.js line.
  function lineFor(d) {
    var line = { id: d.id, quantity: 1 };
    var st = d.stock || {};
    if ((st.onHand | 0) > 0) return line;
    var entries = (st.entries || []).filter(function (e) { return e && e.quantity > 0; });
    if (!entries.length) return line;
    entries.sort(function (a, b) {
      if (!a.date && !b.date) return 0;
      if (!a.date) return 1;
      if (!b.date) return -1;
      return new Date(a.date) - new Date(b.date);
    });
    line.properties = { 'Estimated arrival': fmtDate(entries[0].date) };
    return line;
  }

  function post(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok; }, function () { return false; });
  }

  // Shopify rejects the whole add if any one line can't be sold, so on a
  // failure fall back to one product at a time and report what didn't go in.
  function addAll(list) {
    return post(list.map(function (d) { return lineFor(d); })).then(function (ok) {
      if (ok) return { added: list, failed: [] };
      var added = [], failed = [];
      return list.reduce(function (p, d) {
        return p.then(function () {
          return post([lineFor(d)]).then(function (ok1) { (ok1 ? added : failed).push(d); });
        });
      }, Promise.resolve()).then(function () { return { added: added, failed: failed }; });
    });
  }

  // The slide-out drawer (Slide Cart HQ) renders from its own state; tell it
  // to re-read the cart so its count and contents include what we added.
  function refreshCart() {
    if (typeof window.SLIDECART_UPDATE === 'function') {
      try { return Promise.resolve(window.SLIDECART_UPDATE()).catch(function () {}); } catch (e) {}
    }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      Array.prototype.forEach.call(document.querySelectorAll('.cart-count'), function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden-count', cart.item_count === 0);
      });
    }).catch(function () {});
  }

  function openCart() {
    if (typeof window.SLIDECART_OPEN === 'function') { window.SLIDECART_OPEN(); return; }
    window.location.href = '/cart';
  }

  // Notice in the middle of the screen.
  var notice, hideTimer;
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function names(list) { return list.map(function (d) { return esc(d.title); }).join(', '); }
  function show(html, ok, wait) {
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'gg-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      document.body.appendChild(notice);
      notice.addEventListener('click', function (e) {
        if (e.target.closest('[data-gg-view-cart]')) { hide(); openCart(); }
        else if (e.target.closest('[data-gg-close]') || e.target === notice) hide();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    }
    notice.innerHTML =
      '<div class="gg-notice__card">' +
        '<div class="gg-notice__icon' + (ok ? '' : ' gg-notice__icon--warn') + '" aria-hidden="true">' + (ok ? '&#10003;' : '!') + '</div>' +
        html +
        '<div class="gg-notice__actions">' +
          (ok ? '<button type="button" class="gg-notice__btn gg-notice__btn--dark" data-gg-view-cart>View cart</button>' : '') +
          '<button type="button" class="gg-notice__btn" data-gg-close>Keep shopping</button>' +
        '</div>' +
      '</div>';
    notice.classList.add('is-open');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, wait);
  }
  function hide() { if (notice) notice.classList.remove('is-open'); clearTimeout(hideTimer); }

  function busy(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('is-busy', on);
  }

  function addOne(btn) {
    var d = dataOf(btn.closest('.gg__item'));
    if (!d || d.reason) return;
    busy(btn, true);
    addAll([d]).then(function (res) {
      busy(btn, false);
      if (!res.added.length) {
        show('<p class="gg-notice__title">Couldn\'t add that one</p><p class="gg-notice__text">' + esc(d.title) + ' may have just sold out.</p>', false, 5000);
        return;
      }
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
      refreshCart();
      show('<p class="gg-notice__title">Added to cart</p><p class="gg-notice__text">' + esc(d.title) + '</p>', true, 3500);
    });
  }

  function addGuide(btn) {
    var guide = btn.closest('.gg');
    if (!guide) return;
    var all = Array.prototype.map.call(guide.querySelectorAll('.gg__grid > .gg__item'), dataOf).filter(Boolean);
    var addable = all.filter(function (d) { return !d.reason; });
    var skipped = all.filter(function (d) { return d.reason; });
    if (!addable.length) {
      show('<p class="gg-notice__title">Nothing to add</p><p class="gg-notice__text">These are sold out or call for price right now.</p>', false, 5000);
      return;
    }
    busy(btn, true);
    addAll(addable).then(function (res) {
      busy(btn, false);
      var notAdded = skipped.concat(res.failed);
      if (!res.added.length) {
        show('<p class="gg-notice__title">Couldn\'t add these</p><p class="gg-notice__text">They may have just sold out.</p>', false, 5000);
        return;
      }
      refreshCart();
      var n = res.added.length;
      show(
        '<p class="gg-notice__title">' + n + (n === 1 ? ' item' : ' items') + ' added to cart</p>' +
        (notAdded.length ? '<p class="gg-notice__text">Not added (sold out or call for price): ' + names(notAdded) + '</p>' : ''),
        true, notAdded.length ? 8000 : 4000);
    });
  }

  document.addEventListener('click', function (e) {
    var one = e.target.closest && e.target.closest('[data-gg-add]');
    var all = !one && e.target.closest && e.target.closest('[data-gg-add-all]');
    if (!one && !all) return;
    e.preventDefault();
    if (one) addOne(one); else addGuide(all);
  });
})();
